export const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png']

export const validImageTypesAcceptAttribute = validImageTypes.join(',')

export interface ImageInfo {
  createdAt: string
  createdBy: string
  createdFromIp: string
  croppedPath: string
  croppedSize: { width: number; height: number }
  croppedUrl: string
  id: string
  originalPath: string
  originalSize: { width: number; height: number }
  originalUrl: string
  updatedAt: string
}

export enum UploadTargetType {
  ARTICLE_IMAGES = 'articleImages',
  OG_IMAGE = 'ogImage',
}
